import { Component, Input, OnInit } from '@angular/core';
import { CognitoUser, FnolRequest, FnolRequestListItem, FnolRequestStatus, TasksLabels } from 'src/app/models';
import { Router } from "@angular/router";
import { SidebarDetailsService } from "../../../services/sidebar-details.service";
import { TaskListModalComponent } from "../../task/task-list-modal/task-list-modal.component";
import { LoadingOverlayRef, LoadingService } from "../../../services/loading.service";
import { MatDialog } from "@angular/material/dialog";
import { ApiHttpService } from "../../../services/api-http.service";
import { CognitoUsersService } from "../../../services/cognito-users.service";
import { statusString } from 'src/app/helpers/utility';

@Component({
  selector: 'CPF-fnol-request-list-item',
  templateUrl: './fnol-request-list-item.component.html',
  styleUrls: ['./fnol-request-list-item.component.scss']
})
export class FnolRequestListItemComponent {
  public TasksLabels = TasksLabels;
  public fnolRequest?: FnolRequestListItem;

  @Input()
  set fnolReuqest(fnolRequest: FnolRequest) {
    this.fnolRequest = {
      taskLabels: new Map<TasksLabels, boolean>(
        fnolRequest.labels?.map(label => [label, true]) || []),
      hasUnclosedTasks: fnolRequest.tasks?.some(t => !t.closingDate),
      hasReservedClaims: this.hasReseverClaim(fnolRequest),
      statusString: statusString(fnolRequest.processingStatus),
      assigneeUser: this.cognitoUsersService.getCognitoUsersSync().find(u => u.email === fnolRequest.processingAssignee),
      ...fnolRequest,
    };
  }

  constructor(
    private router: Router,
    private sidebarDetailsService: SidebarDetailsService,
    private loadingService: LoadingService,
    private dialog: MatDialog,
    private apiHttpService: ApiHttpService,
    private cognitoUsersService: CognitoUsersService,
  ) {

  }

  hasReseverClaim(fnolRequest: FnolRequest): boolean {
    return !!fnolRequest?.mfvReserveClaimID || !!fnolRequest?.initialReserveData?.claimID;
  }

  openTasksList(fnolRequest: FnolRequest) {
    if (!fnolRequest) {
      return;
    }

    if (!fnolRequest.tasks) {
      fnolRequest.tasks = [];
    }

    fnolRequest!.tasks = fnolRequest!.tasks.map(t => ({
      ...t,
      includeInComment: t.includeInComment ?? false
    }));
    const dialogRef = this.dialog.open(TaskListModalComponent, {
      data: fnolRequest,
      maxWidth: '1000px',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
      if (this.fnolRequest) {
        this.fnolRequest.hasUnclosedTasks = fnolRequest.tasks?.some(t => !t.closingDate);
      }
      this.save(fnolRequest);
    });
  }

  async save(fnolRequest: FnolRequest) {
    if (!fnolRequest) {
      return;
    }

    const loadingRef: LoadingOverlayRef = this.loadingService.open();
    try {
      const res = await this.apiHttpService.updateFnolRequest(fnolRequest);
    } catch (e) {
      console.error(`Error while saving the FNOL request: ${e}`);
    } finally {
      loadingRef.close();
    }
  }

  openSideDetails(fnolRequest: FnolRequest) {
    this.sidebarDetailsService.setFnolRequest(fnolRequest);
    this.sidebarDetailsService.open();
  }

  openDetails(fnolRequest: FnolRequest) {
    this.router.navigate(['platform', 'fnol-request', fnolRequest.id]);
  }


}
